/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Preview_Hint1Inputs */

const vi_cmstools_preview_hint1 = /** @type {(inputs: Cmstools_Preview_Hint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở bản đã lưu gần nhất (bấm Lưu nháp trước nếu vừa sửa). Link dùng được 30 phút, không ai khác thấy.`)
};

/**

* @param {Cmstools_Preview_Hint1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_preview_hint1 = /** @type {((inputs?: Cmstools_Preview_Hint1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Preview_Hint1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_preview_hint1(inputs)
});
export { cmstools_preview_hint1 as "cmsTools_preview_hint" }